module.exports = __webpack_public_path__ + "static/img/peterpan.6e30af0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/badges/peterpan.png
// module id = 7
// module chunks = 0